import "./MainBanner.css";
import bg from '../../../../assets/images/bg1.jpeg';
import main from '../../../../assets/images/main.png';

function MainBanner({ }) {

    return (
        <div className={`main-banner`} >
            <img src={bg} alt="" className="main-banner__bg"></img>
            <div className="main-banner__text-box">
                <p className="main-banner__text-box__subtitle">КРАСКА ИЗ ШВЕЦИИ</p>
                <div className="main-banner__text-box__separator"></div>
                <p className="main-banner__text-box__title">COLOREX</p>
            </div>
            <img src={main} alt="" className="main-banner__img"></img>
        </div >
    );
}

export default MainBanner;